import { render } from "./AdminFramework.vue?vue&type=template&id=2fc90bfa"
import script from "./AdminFramework.vue?vue&type=script&lang=js"
export * from "./AdminFramework.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__